.head {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
}

.head h1 {
  margin-bottom: 4px;
}

.head p {
  max-width: 640px;
  margin: 0;
}

.panel {
  background: color-mix(in srgb, var(--surface) 88%, transparent);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  padding: 22px 24px;
  margin-bottom: 24px;
  min-width: 0;
}

.panelHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 14px;
  margin-bottom: 18px;
}

.panelHead h2 {
  margin: 0;
  font-size: 21px;
}

.panelHead .spacer {
  flex: 1;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 11px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 400;
  background: var(--pill-bg);
  color: var(--muted);
}

.status::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.statusPublished {
  composes: status;
  color: var(--ok);
  background: color-mix(in srgb, var(--ok) 14%, transparent);
}

.statusDraft {
  composes: status;
  color: var(--accent);
  background: color-mix(in srgb, var(--accent) 14%, transparent);
}

.work {
  display: grid;
  grid-template-columns: 200px minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}

.cardSide {
  display: grid;
  justify-items: center;
  gap: 12px;
  text-align: center;
}

.cardName {
  font-family: var(--font-display);
  font-size: 20px;
  line-height: 1.2;
}

.meaning {
  margin: 0;
  color: var(--muted);
  font-size: 14px;
  line-height: 1.55;
}

.editor {
  display: grid;
  gap: 8px;
  min-width: 0;
}

.editorLabel {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
  color: var(--muted);
  font-size: 13px;
}

.counter {
  font-variant-numeric: tabular-nums;
  color: var(--muted-dim);
  font-size: 12px;
}

.editor textarea {
  min-height: 220px;
  resize: vertical;
  line-height: 1.6;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 4px;
}

.hint {
  color: var(--muted);
  font-size: 13px;
}

.empty {
  display: grid;
  justify-items: center;
  gap: 14px;
  padding: 28px 12px;
  text-align: center;
}

.empty .arch {
  opacity: 0.55;
}

.empty p {
  margin: 0;
  color: var(--muted);
  max-width: 420px;
}

.historyDate {
  color: var(--muted);
  font-size: 12px;
}

@media (max-width: 760px) {
  .panel {
    padding: 18px 16px;
  }

  .work {
    grid-template-columns: minmax(0, 1fr);
    gap: 18px;
  }

  .week {
    grid-template-columns: repeat(8, 76px);
  }
}

.archTrio {
  display: flex;
  gap: 10px;
}

.trio {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.option {
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: 20px;
  background: var(--bg-raised);
  background-image: none;
  color: var(--text);
  font-weight: 400;
  text-align: left;
  min-width: 0;
}

.option:hover {
  opacity: 1;
  border-color: var(--pill-line);
}

.option[aria-pressed='true'] {
  border-color: var(--accent);
  box-shadow: inset 0 0 0 1px var(--accent);
}

.optionTitle {
  display: grid;
  justify-items: start;
  gap: 4px;
  min-width: 0;
}

.optionTitle .cardName {
  font-size: 18px;
}

.optionPreview {
  width: 100%;
  max-width: 560px;
  margin: 18px auto 0;
}

.publishBar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-top: 18px;
  padding-top: 16px;
  border-top: 1px solid var(--line);
}

@media (max-width: 1080px) {
  .trio {
    grid-template-columns: minmax(0, 1fr);
  }
}
